import React, { useState, forwardRef, useImperativeHandle } from 'react';
import PropTypes from 'prop-types';
import { Icon, Button } from '@unite-us/app-components';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ConversationTextField = (_ref, ref) => {
  let {
    getConversationAndSend,
    textAreaId,
    initialValue,
    recipientId,
    showNewMessage,
    readOnly
  } = _ref;
  const [textInputValue, setTextInputValue] = useState(initialValue || '');
  const isDisabled = textInputValue.trim().length === 0 || !recipientId && showNewMessage;
  const handleKeyDown = event => {
    if (event.metaKey && event.key === "Enter") {
      getConversationAndSend(textInputValue);
      setTextInputValue("");
    }
  };
  useImperativeHandle(ref, () => ({
    getTextInputValue: () => textInputValue
  }));
  return /*#__PURE__*/_jsxs("div", {
    className: "w-full m-0 flex flex-col absolute inset-x-0 bottom-0",
    style: {
      height: "27%"
    },
    children: [/*#__PURE__*/_jsx("textarea", {
      id: textAreaId,
      rows: "4",
      className: "ml-6 mr-6 mt-6 mb-3 p-4 h-full text-sm text-black bg-med-blue-50 rounded-md font-regular-font ".concat(readOnly ? 'bg-gray-200' : ''),
      style: {
        border: '1px solid #cbd5e0'
      },
      placeholder: "Enter your message here...",
      onChange: e => {
        setTextInputValue(e.target.value);
      },
      value: textInputValue,
      onKeyDown: handleKeyDown,
      readOnly: readOnly
    }), /*#__PURE__*/_jsxs("div", {
      className: "button-wrapper text-right mr-6 ml-6",
      children: [/*#__PURE__*/_jsx("p", {
        className: "font-regular-font float-left italic text-mc-gray text-13px",
        children: "Avoid including sensitive information (such as PHI) in your message."
      }), /*#__PURE__*/_jsx(Button, {
        id: "send-message-button",
        primary: true,
        className: "float-right mb-5",
        icon: {
          name: 'Email',
          color: '#FFFFFF',
          position: 'left'
        },
        disabled: isDisabled,
        label: "Send",
        onClick: () => getConversationAndSend(textInputValue) && setTextInputValue('')
      })]
    })]
  });
};
ConversationTextField.propTypes = {
  getConversationAndSend: PropTypes.func.isRequired,
  textAreaId: PropTypes.string.isRequired,
  initialValue: PropTypes.string,
  readOnly: PropTypes.bool.isRequired
};
ConversationTextField.defaultProps = {
  initialValue: ''
};
export default /*#__PURE__*/forwardRef(ConversationTextField);
//# sourceMappingURL=conversationTextField.js.map